import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, isPrint = false, className = "", y = 28 }) => {
  if (isPrint) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="w-2.5 h-2.5 bg-brand shrink-0" />
    <span
      className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] ${
        dark ? "text-white/60" : "text-slate-500"
      }`}
    >
      {children}
    </span>
  </div>
);

export const SlideShell = ({ children, className = "" }) => (
  <div
    className={`h-[100dvh] w-full overflow-hidden flex flex-col justify-center px-6 sm:px-12 lg:px-20 xl:px-28 pt-16 pb-20 ${className}`}
  >
    <div className="w-full max-w-7xl mx-auto">{children}</div>
  </div>
);

export const SectionHead = ({ slide, isPrint, dark = false, compact = false }) => (
  <div className="max-w-3xl">
    <Reveal isPrint={isPrint}>
      <Eyebrow dark={dark}>{slide.eyebrow}</Eyebrow>
    </Reveal>
    <Reveal isPrint={isPrint} delay={0.08}>
      <h2
        className={`font-display font-extrabold tracking-tight leading-[1.05] ${
          compact ? "text-3xl sm:text-4xl" : "text-3xl sm:text-4xl lg:text-5xl"
        } ${dark ? "text-white" : "text-ink"}`}
      >
        {slide.title}
      </h2>
    </Reveal>
    {slide.subtitle && (
      <Reveal isPrint={isPrint} delay={0.16}>
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-white/60" : "text-slate-600"}`}>
          {slide.subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
